import { render, staticRenderFns } from "./LegoCard.vue?vue&type=template&id=d0f4967e&scoped=true&"
import script from "./LegoCard.vue?vue&type=script&lang=ts&"
export * from "./LegoCard.vue?vue&type=script&lang=ts&"
import style0 from "./LegoCard.vue?vue&type=style&index=0&id=d0f4967e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f4967e",
  null
  
)

export default component.exports